export default __webpack_public_path__ + "static/media/human-resource.be04722c.png";